import React from 'react';
import styled from 'styled-components';

import { SystemAlert } from '../systemAlert';

import EFCLayout from './efcLayout';
import { PageHeader } from './components/header';
import Footer from './components/footer';
import { SkipToContentLink } from './components/skipToContentLink';

const MainContentWrapper = styled.div`
  width: 100%;
  padding: var(--ds-size-4) var(--ds-size-10);
  flex-grow: 1;
`;

const MainContentContainer = styled.div`
  margin: 0 auto;
  max-width: var(--max-width);
`;

const isBalderDesign = window.config.VITE_BALDER_DESIGN_ENABLED;

export const Layout = ({ children }: { children: React.ReactNode }) => {
  if (!isBalderDesign) {
    return <EFCLayout fullWidth>{children}</EFCLayout>;
  }

  return (
    <>
      <SkipToContentLink />
      <SystemAlert />
      <PageHeader />
      <MainContentWrapper id="main">
        <MainContentContainer>{children}</MainContentContainer>
      </MainContentWrapper>
      <Footer />
    </>
  );
};
